export default __webpack_public_path__ + "static/media/Icon material-timer.21aff3fc.svg";